import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 1 }

import {computed, ref} from 'vue';
import {IFilter, IFiltersData} from "~/cabinet/vue/interface/filter/Interfaces";
import {__} from "~/ts/library/Translate";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {mobileFullWidthButtonClass} from "~/core-ui/ts/CoreUiHelpersMixin";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import TreeSelectorDialog from "~/cabinet/vue/interface/treeSelectorDialog/TreeSelectorDialog.vue";


const __default__ = {
    name: "MyFilterAdd"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    filtersData: {},
    availableFilters: {},
    buttonText: { default: __("Добавить фильтр") }
  },
  emits: ["add-filter"],
  setup(__props: any, { emit: __emit }) {

let props = __props;


let emits = __emit;

function filtersOfGroup(groupId?: string): IFilter[] {
    let result = [];
    let filters = props.availableFilters;
    for (let i = 0; i < filters.length; i++) {
        let filter: IFilter = filters[i];
        if (!groupId || filter.group == groupId) {
            result.push(filter);
        }
    }
    return result;
}

let needDisplayGroup = computed(() => {
    return ObjectHelper.arrayFromDictionary(props.filtersData.groups).length > 1;
});

let groups = computed(() => {
    let result = [];
    let groups = props.filtersData.groups;
    for (let i in props.filtersData.groups) {
        if (props.filtersData.groups.hasOwnProperty(i)) {
            let group = groups[i];
            let filters = filtersOfGroup(group.id);
            if (filters.length) {
                result.push({
                    group: group,
                    filters: filters
                });
            }
        }
    }
    return result;
});

let dialogVisible = ref(false);

function showDialog() {
    dialogVisible.value = true;
}

function addFilter(filter: IFilter) {
    dialogVisible.value = false;
    emits('add-filter', filter);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_unref(groups).length < 0)
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        class: "w-100 w-md-auto",
        trigger: "click",
        placement: "bottom-start",
        onCommand: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('add-filter', $event)))
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_unref(needDisplayGroup))
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 0,
                        disabled: "",
                        divided: index > 0 ? true : null
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.group.descr), 1)
                        ]),
                        _: 2
                      }, 1032, ["divided"]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.filters, (filter) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: filter.id,
                      command: filter
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(filter.descr), 1)
                      ]),
                      _: 2
                    }, 1032, ["command"]))
                  }), 128))
                ], 64))
              }), 256))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: _normalizeClass(_unref(mobileFullWidthButtonClass)),
            type: "primary",
            plain: "",
            round: ""
          }, {
            icon: _withCtx(() => [
              _createVNode(FontAwesomeIcon, { icon: "plus" })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(__props.buttonText), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          class: _normalizeClass(_unref(mobileFullWidthButtonClass)),
          type: "primary",
          plain: "",
          round: "",
          onClick: showDialog
        }, {
          icon: _withCtx(() => [
            _createVNode(FontAwesomeIcon, { icon: "plus" })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(__props.buttonText), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        (_unref(dialogVisible))
          ? (_openBlock(), _createBlock(TreeSelectorDialog, {
              key: 0,
              visible: _unref(dialogVisible),
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
              groups: _unref(ObjectHelper).arrayFromDictionary(_unref(props).filtersData.groups),
              items: _unref(props).availableFilters,
              "not-found-message": "Фильтры не найдены",
              "category-column-header": "Категории фильтров",
              onSelect: _cache[2] || (_cache[2] = ($event: any) => (addFilter(_unref(props).filtersData.filters[$event])))
            }, null, 8, ["visible", "groups", "items"]))
          : _createCommentVNode("", true)
      ]))
}
}

})